import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { useLang } from "./i18n";
document.documentElement.lang = useLang.getState().lang;
import "./styles.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
